import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {RouterModule, Routes} from '@angular/router';
import {
  MatAutocompleteModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatInputModule,
  MatRadioModule,
  MatSelectModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatMenuModule,
  MatSidenavModule,
  MatToolbarModule,
  MatListModule,
  MatGridListModule,
  MatCardModule,
  MatStepperModule,
  MatTabsModule,
  MatExpansionModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatChipsModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatDialogModule,
  MatTooltipModule,
  MatSnackBarModule,
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  MatNativeDateModule
} from '@angular/material';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {HomeComponent} from './pages/home/home.component';
import {Observable} from 'rxjs';
import {ApiAccessService} from './services/network/api-access.service';
import {DialogsService} from './services/dialog.service';
import {
  ConfirmDialogComponent
} from './parts/dialog/confirm-dialog/confirm-dialog.component';
import {
  AlertDialogComponent
} from './parts/dialog/alert-dialog/alert-dialog.component';
import {
  ToastSuccessComponent
} from './parts/toast-success/toast-success.component';
import {SettingsComponent} from './pages/settings/settings.component';
import {LogInComponent} from './pages/log-in/log-in.component';
import {RealtorPortalService} from './services/network/realtor-portal.service';
import {QuoteComponent} from './pages/quote/quote.component';
import {
  PlanSelectionComponent
} from './parts/plan-selection/plan-selection.component';
import {
  MobileWizardProgressIndicatorComponent
} from './parts/mobile-wizard-progress-indicator/mobile-wizard-progress-indicator.component';
import {
  ViewCoverageDialogComponent
} from './parts/plan-selection/view-coverage/view-coverage.component';
import {
  ExtendedAreaDialogComponent
} from './parts/plan-selection/extended-area/extended-area.component';
import {PoliciesComponent} from './pages/policies/policies.component';
import {QuotesComponent} from './pages/quotes/quotes.component';
import {
  CoverageMapsComponent
} from './pages/coverage-maps/coverage-maps.component';
import {LogOutComponent} from './pages/log-out/log-out.component';
import {OrdersComponent} from './pages/orders/orders.component';
import {MetricsComponent} from './pages/metrics/metrics.component';
import {OrderComponent} from './pages/order/order.component';
import {ViewQuoteComponent} from './pages/view-quote/view-quote.component';
import {RegisterComponent} from './pages/register/register.component';
import {NgxMaskModule} from 'ngx-mask';
import {
  ResetPasswordComponent
} from './pages/reset-password/reset-password.component';
import {
  FederatedLoginComponent
} from './pages/federated-login/federated-login.component';
import { WLComponent } from './pages/warranty-link/warranty-link.component';

const appRoutes: Routes = [
  {path: 'home', component: HomeComponent, data: {title: 'Home'}},
  {path: 'settings', component: SettingsComponent},
  {path: 'log-in', component: LogInComponent},
  {path: 'quote', component: QuoteComponent},
  {path: 'service-contracts', component: PoliciesComponent},
  {path: 'quotes', component: QuotesComponent},
  {path: 'coverage-maps', component: CoverageMapsComponent},
  {path: 'log-out', component: LogOutComponent},
  {path: 'orders', component: OrdersComponent},
  {path: 'metrics', component: MetricsComponent},
  {path: 'order/:id', component: OrderComponent},
  {path: 'view-quote/:id', component: ViewQuoteComponent},
  {path: 'register', component: RegisterComponent},
  {
    path: 'federated-login/:key',
    component: FederatedLoginComponent,
  },
  {path: 'order-quote/:quoteId', component: QuoteComponent},
  {path: 'reset-password', component: ResetPasswordComponent},
  {path: 'warranty-link/:policyId', component: WLComponent},
  {path: 'warranty-link/:brand/:policyId', component: WLComponent},
  {path: '', redirectTo: '/home', pathMatch: 'full'},

];


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AlertDialogComponent,
    ToastSuccessComponent,
    ConfirmDialogComponent,
    SettingsComponent,
    LogInComponent,
    QuoteComponent,
    PlanSelectionComponent,
    MobileWizardProgressIndicatorComponent,
    ViewCoverageDialogComponent,
    ExtendedAreaDialogComponent,
    PoliciesComponent,
    QuotesComponent,
    CoverageMapsComponent,
    LogOutComponent,
    OrdersComponent,
    MetricsComponent,
    OrderComponent,
    ViewQuoteComponent,
    RegisterComponent,
    ResetPasswordComponent,
    ResetPasswordComponent,
    FederatedLoginComponent,
    WLComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    NgxMaskModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    MatExpansionModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatNativeDateModule,
    [BrowserAnimationsModule],
  ],
  providers: [
    ApiAccessService,
    DialogsService,
    RealtorPortalService,
  ],
  entryComponents: [
    ConfirmDialogComponent,
    AlertDialogComponent,
    ToastSuccessComponent,
    ViewCoverageDialogComponent,
    ExtendedAreaDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
